export default __webpack_public_path__ + "static/sliced_citrus2-0bee0fd8bb0c5d84f07b4b4198eea2ee.jpg";